module.exports = __webpack_public_path__ + "img/logo-training.f96db3e4.svg";